import { object, node } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { SummaryColumns } from "@repo/utils";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure,
  PinnableCell,
  WorkTypeResourceSelect,
} from "@tools";
import { SummaryNestedRowActions } from "./components";
import classnames from "classnames";

export const TitleCell = observer(({
  resource,
  children,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  
  const { isTimelineTableUsed } = structure.settings;
  const { name } = resource;

  return (
    <PinnableCell
      boldText keepMinSize
      colName={ SummaryColumns.TITLE }
      pinnedLeft
      tableDepth={2}
      allowOverflowDisplay
      actions={<SummaryNestedRowActions resource={resource} /> }
      containers={children}
      pinActionsLeft={!useProfitability && !visibilityMode}
      actionsContainerWidth={4*24}
    >
      {
        allowEdition && !isTimelineTableUsed
          ? <WorkTypeResourceSelect resource={resource} navigationKey="sm-name" />
          : <span
              className={classnames(
                "name",
                "preset-summaryTitleText",
                !name?.length && "semi-transparent"
              )}
            >
              {name || t("common.unnamed")}
            </span>
      }
    </PinnableCell>
  )
})

TitleCell.propTypes = {
  resource: object.isRequired,
  children: node,
}